import { defineComponent } from 'vue';

import { getCountries, getCountryMask } from '@/bundles/Common/helpers/getCountries';
import { ICountry } from '@/bundles/Common/interfaces/ICountries';
import { Nullable } from '@/utils/types';
import { getAccountCountry } from '@/bundles/Companies/helpers/companyDefaultData';

interface ICountriesMasksMixin {
  countriesList: ICountry[];
}

const CountriesMasksMixin = defineComponent({
  data: (): ICountriesMasksMixin => ({
    countriesList: [],
  }),

  created () {
    this.setCountriesList();
  },

  methods: {
    async setCountriesList () {
      this.countriesList = await getCountries();
    },
    getCountryMask (code: Nullable<string>): string {
      return getCountryMask(this.countriesList, code || getAccountCountry());
    }
  }
})

export { CountriesMasksMixin };
